module.exports = __webpack_public_path__ + "media/images/sarapoint/t2-551dafc13b4d1897c6200d78d470d0e6.png";